/**
 * The `instantsearch` namespace the UMD build used to put on window.
 *
 * The ES build leaves `.widgets`, `.connectors` and `.stateMappings` off the default
 * export (it throws when you touch them), so they are put back here — with only the
 * pieces this plugin uses, so the bundle does not carry every widget InstantSearch has.
 * Need another widget? Import it below and add it to the matching object.
 */
import instantsearch from 'instantsearch.js/es';
import {
	clearRefinements,
	configure,
	hierarchicalMenu,
	hits,
	infiniteHits,
	panel,
	rangeInput,
	rangeSlider,
	refinementList,
	searchBox,
	sortBy,
	stats,
} from 'instantsearch.js/es/widgets';
import {
	connectClearRefinements,
	connectRefinementList,
} from 'instantsearch.js/es/connectors';
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings';

const namespace = ( options ) => instantsearch( options );

namespace.widgets = {
	clearRefinements,
	configure,
	hierarchicalMenu,
	hits,
	infiniteHits,
	panel,
	rangeInput,
	rangeSlider,
	refinementList,
	searchBox,
	sortBy,
	stats,
};
namespace.connectors = { connectClearRefinements, connectRefinementList };
namespace.stateMappings = { singleIndex };

export default namespace;
